import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import store from '@/store'
import Configuration from '@/utils/configuration'

var protocol = Configuration.value('backendProtocol')
var host = Configuration.value('cloudAppsAPIHost')

axios.defaults.baseURL = `${protocol}://${host}`

axios.interceptors.request.use((config) => {
  const noAuthorizationHeaderRequired = config.headers['x-validate-file-exists'] === true
  const currentUserExists = !!store.getters['cpAuth/currentUser']
  
  if (currentUserExists && !noAuthorizationHeaderRequired) {
    // Set JWT before request is sent
    config.headers.common['Authorization'] = `Bearer ${store.getters['cpAuth/token']}`
    config.headers.common['Content-Type'] = 'application/json'
  }
  return config
}, (error) => {
  // Do something with request error
  return Promise.reject(error)
})

Vue.use(VueAxios, axios)
